'use strict';

var ResourceFactory = require('../Factory');

var definition = {
  name: 'AnnotationLayer',
  basePath: ':basePath',
  endpoint: 'annotationLayers',
  debug: false,
  relations: {
    belongsTo: {
      Annotation: { // Annotate Resource Name
        localKey: 'annotationId',
        localField: 'annotation', // will add this property to the layer data
        parent: true
      },
      Overlay: {
        localKey: 'overlayId',
        localField: 'overlay'
      }
    }
  },
  methods: null
};

var AnnotationLayerResource = function (DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {
  return {
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {},

    // computed methods to be passed to js-data DS
    computed: {},

    // definition to be formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },
    group: true,
    hooks: {},

    // model methods to be passed to js-data DS
    modelMethods: {}
  };
};

module.exports = AnnotationLayerResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/annotationLayer/AnnotationLayerResource.js